// 单文件引入方式

import SortableInputsField from './ZuiSortableInputsField.vue'

export default {
  install(Vue) {
    Vue.component('ZuiSortableInputsField', SortableInputsField)
  }
}

export { SortableInputsField }
